import { AppDispatch } from '@app/store';
import {
  APP_AFFILIATE_CLICK_ID,
  APP_AFFILIATE_OFFER_ID,
  APP_AFFILIATE_OFFER_TYPE,
  APP_PLATFORM,
  APP_PLATFORM_APP_STORE,
} from '@common/constants';
import { setAppPlatform, setAppPlatformAppStore } from '@features/app/slice/appSlice';
import { IAppState } from '@features/app/slice/appSlice.type';
import { NavigateFunction } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

export const handleAffiliateParams = (
  searchParams: URLSearchParams,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  const platform = searchParams.get(APP_PLATFORM) as IAppState['platform'];
  const platformAppStore = searchParams.get(APP_PLATFORM_APP_STORE) as IAppState['platformAppStore'];
  const affOid = searchParams.get('af_oid');
  const affCid = searchParams.get('af_cid');
  const affOType = searchParams.get('af_otype');

  if (affOid) {
    sessionStorage.setItem(APP_AFFILIATE_OFFER_ID, affOid);
  }
  if(affCid) {
    sessionStorage.setItem(APP_AFFILIATE_CLICK_ID, affCid);
  }

  if (affOType) {
    sessionStorage.setItem(APP_AFFILIATE_OFFER_TYPE, affOType);

    switch (affOType) {
      case 'signup':
        navigate('sign-up');
        break;
      case 'deposit':
        navigate('deposit');
        break;
      case 'first_deposit':
        navigate('deposit');
        break;
      default:
        break;
    }
  }

  if (platform) {
    reactLocalStorage.set(APP_PLATFORM, platform);
    dispatch(setAppPlatform(platform));
  }

  if (platformAppStore) {
    reactLocalStorage.set(APP_PLATFORM_APP_STORE, platformAppStore);
    dispatch(setAppPlatformAppStore(platformAppStore));
  }
};

export const handleRemoveAffiliateParams = (affOType?: string | null) => {
  if (affOType != 'marketing') {
    sessionStorage.removeItem(APP_AFFILIATE_OFFER_ID);
    sessionStorage.removeItem(APP_AFFILIATE_CLICK_ID);
    sessionStorage.removeItem(APP_AFFILIATE_OFFER_TYPE);
  }
};
